import AssetUpload from 'components/AssetUpload';
import ImageSpecifications from 'components/ImageSpecifications';
import SlugInput from '../../../components/form-items/SlugInput';
import { Card, Form, Input } from 'antd';
import { CreateLayout } from 'components/layout/layout/CreateLayout';
import { EcommerceIconComponent } from 'assets/icons/ecommerce';
import { IInstructor } from 'interfaces/instructors';
import { PageHeader } from 'components/professor_area/PageHeader';
import { applyImageSizeRestriction } from 'utils/apply-image-size-restriction';
import { shouldApplyImageRestrictions } from 'utils/should-apply-image-restrictions';
import { useForm } from '@refinedev/antd';

export const InstructorCreate = () => {
  const { formProps, saveButtonProps } = useForm<IInstructor>();

  return (
    <CreateLayout saveButtonProps={saveButtonProps} title="Criar instrutor">
      <PageHeader title="Criar instrutor" icon={EcommerceIconComponent} />

      <Card>
        <Form {...formProps} layout="vertical">
          <ImageSpecifications
            title="Especificações Avatar"
            size="200kb"
            format="jpeg/jpg/png"
          />
          <Form.Item
            label={!shouldApplyImageRestrictions() ? 'Avatar' : ''}
            name="avatar"
            rules={[
              {
                required: true
              }
            ]}
          >
            <AssetUpload
              accept="image/png, image/jpeg"
              type="instructor"
              maxSize={applyImageSizeRestriction('avatar')}
            />
          </Form.Item>
          <SlugInput />
          <Form.Item
            label="Name"
            name="name"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Cabeçalho"
            name="headline"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Biografia"
            name="bio"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input.TextArea />
          </Form.Item>
        </Form>
      </Card>
    </CreateLayout>
  );
};
